import { useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

interface FirstVotePopupProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  isLastVote?: boolean
  currentVoteCount?: number
}

export function FirstVotePopup({ 
  isOpen, 
  onOpenChange, 
  isLastVote = false,
  currentVoteCount = 1
}: FirstVotePopupProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  const handleNavigation = () => {
    onOpenChange(false)
    if (isLastVote) {
      navigate('/feed')
    } else {
      navigate('/fotw')
    }
  }

  const getTitle = () => {
    if (isLastVote) {
      return t('fotw.firstVote.lastVoteTitle')
    } else if (currentVoteCount === 1) {
      return t('fotw.firstVote.firstVoteTitle')
    } else if (currentVoteCount === 2) {
      return t('fotw.firstVote.secondVoteTitle')
    }
    return t('fotw.firstVote.firstVoteTitle')
  }

  const getButtonText = () => {
    if (isLastVote) {
      return t('fotw.firstVote.lastVoteButtonText')
    }
    return t('fotw.firstVote.buttonText')
  }

  if (!mounted || !isOpen) return null

  return createPortal(
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 z-[100] bg-black/50 animate-in fade-in-0"
        onClick={() => onOpenChange(false)}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-[100] flex items-center justify-center pointer-events-none p-4">
        <div className="bg-background rounded-[var(--card-radius)] shadow-lg max-w-sm w-full animate-in zoom-in-95 pointer-events-auto">
          {/* Content */}
          <div className="p-6 space-y-4 text-center">
            {/* Title */}
            <h2 className="text-xl font-semibold text-foreground">{getTitle()}</h2>

            {/* Button */}
            <button 
              onClick={handleNavigation}
              className="w-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold py-3 rounded-lg transition-colors"
            >
              {getButtonText()}
            </button>
          </div>
        </div>
      </div>
    </>,
    document.body
  )
} 